import {type Dispatch} from 'react';
import {IconButton, Stack, TextField, Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import UndoIcon from '@mui/icons-material/Undo';
import {actionTypeEnum, type IFishGroup, type IFishGroupAction} from './helpers/reducer';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';

export const FishGroupName = ({
  label,
  state,
  dispatch,
}: {
  label: string;
  state: IFishGroup;
  dispatch: Dispatch<IFishGroupAction>;
}): JSX.Element => {
  const {t} = useTranslation('common');
  const nameValue = state.nameAttribute?.value ?? '';
  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Stack direction={'row'} width={120} alignItems={'center'} spacing={1}>
        <Typography variant="body2" color={'secondary'}>
          {label}
        </Typography>
        {state.nameAttribute?.isPinned && state?.nameAttribute.isPinned && (
          <Tooltip title={t('isEdited')}>
            <DriveFileRenameOutlineRoundedIcon fontSize={'inherit'} color="primary" />
          </Tooltip>
        )}
      </Stack>
      <TextField
        size="small"
        value={nameValue === 'mixed' ? t('mixed') : nameValue}
        onChange={(event) => {
          dispatch({type: actionTypeEnum.setCustomName, nameValue: event.target.value});
        }}
        fullWidth
        data-testid="fish-group-name"
        InputProps={{
          endAdornment: (
            <Tooltip title={t('removeOverride')} placement="bottom-end">
              <IconButton
                size="small"
                edge="end"
                onClick={() => {
                  dispatch({type: actionTypeEnum.resetName});
                }}
              >
                <UndoIcon color="secondary" fontSize="inherit" />
              </IconButton>
            </Tooltip>
          ),
        }}
      />
    </Stack>
  );
};
